import { useCallback, useContext } from 'react'

import { faAward, faDiploma } from '@fortawesome/pro-regular-svg-icons'
import { Box } from '@material-ui/core'
import { SelectableIconChips } from '@scoir/college-search'

import ContentModalContext from '../../ContentModalProvider/Context'
import { FIELD_NAMES, LABELS } from '../../components/constants'

const field = FIELD_NAMES.CREDITS_AWARDED

const Credits = () => {
  const { item, onUpdateField, onUpdateFields, validation } = useContext(ContentModalContext)

  const value = item[field]

  const onSelect = useCallback(
    (value: boolean) => {
      if (!value) {
        // if non-credit, min & max credits should be reset to 0
        onUpdateFields({
          [field]: value,
          [FIELD_NAMES.MIN_CREDITS]: 0,
          [FIELD_NAMES.MAX_CREDITS]: 0,
        })
        validation.clearErrors([LABELS.MIN_CREDITS, LABELS.MAX_CREDITS])
      } else {
        onUpdateField(field, value)
      }
    },
    [onUpdateFields, onUpdateField, validation],
  )

  return (
    <Box
      display="flex"
      gridGap={2}
    >
      <SelectableIconChips
        gridItemProps={{ xs: 6 }}
        onSelect={onSelect}
        options={[
          {
            title: LABELS.NON_CREDIT,
            faIcon: faAward,
            value: false,
            selected: !value,
          },
          {
            title: LABELS.CREDITS_AWARDED,
            faIcon: faDiploma,
            value: true,
            selected: value,
          },
        ]}
      />
    </Box>
  )
}

export default Credits
